import * as types from "./types";

export default {
  [types.CALL_LOADING]({ commit }, isLoading) {
    commit(types.MUTATE_LOADING, isLoading);
  }
};
